import CommonSearch from "../../components/commonSearch/CommonSearch";
import React, { useState, useEffect } from 'react';
import directoryServices from "./directoryServices";
import AssetManagement from "./Add Slider/AssetManagement";
import ArtistManagement from "./Add Slider/ArtistManagement";
import AddCreator from "./Add Slider/addCreator";
import DirectoryAnalytic from "./Analytic/DirectoryAnalytic";
import DeleteDialogueBox from "../Common/deleteDialogue"; 
import Summary from "./summary";
import { CommonUtilities } from '../../commonUtils';
import Pagination from "components/Common/newPagination";

export default function Creator(param: any) {

    let [totalRow, settotalRow] = useState(0);
    let [resetVal, setResetVal] = useState(false);
    let [deleteJob, setDelete] = useState(false);
    let [exclude, setExclude] = useState<any>([]);
    let [searchFor, setsearchFor] = useState<any>([]);
    let [viewAllList, setviewAllList] = useState("");
    let [detailSubTab, setdetailSubTab] = useState(1);
    let [detailView, setdetailView] = useState(false);
    let [openInclude, setOpenInclude] = useState(false);
    let [detailMainTab, setdetailMainTab] = useState(5);
    let [activeCategory, setActiveCategory] = useState("All");
    let [categoryList, setCategoryList] = useState<any[]>([]);
    let [selectedDetail, setselectedDetail] = useState<any>([]);
    let [dialogueOpenView, setdialogueOpenView] = useState(false);
    let [creatorAssetList, setcreatorAssetList] = useState<any>([]);
    let [directoryViewAll, setdirectoryViewAll] = useState<any>([]);
    let [creatorAssettotalRow, setcreatorAssettotalRow] = useState(0);
    let [dialogueAddOpenView, setdialogueAddOpenView] = useState(false);
    let [activedetailCategory, setActivedetailCategory] = useState("All");
    let [creatorRelatedAsset, setcreatorRelatedAsset] = useState<any>([]);
    let [creatorRelatedArtist, setcreatorRelatedArtist] = useState<any>([]);
    let [creatorAssetCategory, setcreatorAssetCategory] = useState<any>([]);
    let [directoryFullListing, setdirectoryFullListing] = useState<any[]>([]);
    let [dialogueArtistOpenView, setdialogueArtistOpenView] = useState(false);
    let [associatedclassification, setassociatedclassification] = useState<any>([]);
    let [associatedSubclassification, setassociatedSubclassification] = useState<any>([]);

    var loop = 0;

    var relatedAssetPayLoad = { creatorCode: selectedDetail.kontactCode, UnRelatedAssets: 1, pageNumber: 1, pageSize: 10 }
    var creatorAssetPayLoad = { assetType: "T", categoryName: "", creatorCode: selectedDetail.kontactCode, display: "Category", pageNumber: 1, pageSize: 10 }
    var bundlePayLoad = { pageNumber: 1, pageSize: 10, creatorCode: selectedDetail.kontactCode }
    var SubclassFicationPayload = { area: "ContactType", referenceCode: "", text: "", pageNumber: 1, pagesize: 10 }
    var pagination = { 'pageSize': 10, 'pageNumber': 1, "display": "Category", "type": "Creators", "searchFor": searchFor, "exclude": "" }

    useEffect(() => {

        console.log(param)
        console.log("LandingListing")
        setActiveCategory("All");
        if (loop === 0) {
            console.log(loop)
            //LandingListing();
            loop = loop + 1;
        }

    }, [param])


    useEffect(() => {
        if (activedetailCategory === "All") {
            creatorAssetCategory = []
            setcreatorAssetCategory(creatorAssetCategory)
        }

        for (var $i = 0; $i < creatorAssetList.length; $i++) {

            if (creatorAssetList[$i].categoryName !== ' ' && activedetailCategory === "All" && (creatorAssetCategory.length <= creatorAssetList.length)) {
                creatorAssetCategory.push(creatorAssetList[$i].categoryName)
                setcreatorAssetCategory(creatorAssetCategory)
            }
        }
    }, [creatorAssetList])

    const LandingListing = () => {
        console.log("LandingListing")
        console.log(pagination)

        setdirectoryViewAll([]);
        setviewAllList("");

        console.log(pagination?.searchFor)
        console.log(typeof (pagination?.searchFor))
        console.log(pagination?.searchFor?.length)

        if (typeof (pagination?.searchFor) === "object" && Object.keys(pagination?.searchFor)?.length === 0) {
            pagination.searchFor = ""
        }

        if (Array.isArray(pagination?.searchFor) && (pagination?.searchFor)?.length === 0) {
            pagination.searchFor = ""
        } 

        directoryServices.creatorsListing({ ...pagination }).then((res) => {
            res.map((values: any) => {

                if (values.categoryName !== ' ' && (categoryList.filter((e: any) => e === values.categoryName))?.length === 0) {
                    categoryList.push(values.categoryName)
                    setCategoryList(categoryList);
                    setExclude(categoryList)

                }
                if (values.categoryName === ' ' && (categoryList.filter((e: any) => e === "Uncategorised"))?.length === 0) {
                    categoryList.push("Uncategorised")
                    setCategoryList(categoryList)
                    setExclude(categoryList)
                }
            })
            setdirectoryFullListing(res)
            settotalRow(res[0] ? res[0].totalRows : 0)

        })
    }

    const SearchForHandle = (e: any, sts: any) => {
        console.log(e)
        console.log(sts)
        if (sts === false || sts === true) {
            searchFor = e;
            setsearchFor(e)
            pagination.searchFor = e?.searchFor;
            pagination = { ...pagination, ...searchFor }
        }

        console.log(pagination?.searchFor)
        console.log(activeCategory)
        console.log(pagination)
        if ((sts === true) && activeCategory === "All") {
            resetVal = true;
            setResetVal(resetVal)
            directoryServices.creatorsListing(pagination).then((res) => {

                let clases_list: any = [];
                directoryServices.zFreeTextListing({ formArea: "Creators" }).then((valueListing: any) => {

                    for (var i = 0; i < valueListing.length; i++) {
                        clases_list.push(valueListing[i].useFreeText)
                    }

                    clases_list.push("Uncategorised")

                    if (clases_list.length > 0) {
                        console.log(clases_list)
                        exclude = clases_list;
                        setExclude(exclude);
                    }
                })

                setdirectoryFullListing(res)
                settotalRow(res[0] ? res[0].totalRows : 0)

            })

            setTimeout(function () {
                resetVal = false;
                setResetVal(resetVal)
            }, 3000);
        }

        if ((sts === true) && activeCategory !== "All") {
            resetVal = true;
            setResetVal(resetVal)
            directoryServices.creatorsListingAll(pagination).then((res) => {
                setdirectoryFullListing(res);
                settotalRow(res[0] ? res[0].totalRows : 0)
            })

            setTimeout(function () {
                resetVal = false;
                setResetVal(resetVal)
            }, 3000);
        }

        console.log(exclude)
        exclude = categoryList;
        setExclude(exclude);
    }

    const viewAll = (e: any) => {
        console.log("viewAll")
        setviewAllList(e);

        directoryServices.creatorsListing({ ...{ "categoryName": e }, ...pagination }).then((res) => {
            for (var $i = 0; $i < res?.length; $i++) {

                if (res[$i].categoryName === e) {
                    directoryViewAll = res[$i].categoryDetails
                    setdirectoryViewAll(directoryViewAll)
                }
            }
        })
    }

    const paginationAllCategory = (e: any) => {
        console.log(e);

        if (pagination.pageNumber !== e.pagination.pageNumber || pagination.pageSize !== e.pagination.pageSize) {
            pagination.pageNumber = e.pagination.pageNumber;
            pagination.pageSize = e.pagination.pageSize;
            viewAllList = e.categoryName
            setviewAllList(viewAllList)

            viewAll(viewAllList);

        }
    }

    const creatorAsset = (e: any) => {

        if (e !== "All") {
            creatorAssetPayLoad.categoryName = e;
        } else { creatorAssetPayLoad.categoryName = ""; }

        if (detailSubTab === 1) {
            creatorAssetPayLoad.assetType = 'T';
        } else if (detailSubTab === 2) {
            creatorAssetPayLoad.assetType = "S";
        } else if (detailSubTab === 3) { creatorAssetPayLoad.assetType = "R"; }

        console.log(detailSubTab)
        setselectedDetail(selectedDetail)

        creatorAssetPayLoad.creatorCode = selectedDetail.kontactCode;
        bundlePayLoad.creatorCode = selectedDetail.kontactCode;
        relatedAssetPayLoad.creatorCode = selectedDetail.kontactCode;

        console.log(detailMainTab)
        if (detailSubTab === 1) {
            CommonUtilities.BtnLoading("assets");
        }

        if (detailSubTab < 4) {
            directoryServices.MainAssetListing(creatorAssetPayLoad).then((res) => {
                setcreatorAssetList(res)
                creatorAssettotalRow = res[0] ? res[0].totalRows : 0;
                setcreatorAssettotalRow(creatorAssettotalRow)
                for (var $i = 0; $i < res.length; $i++) {

                    if (res[$i].categoryName !== ' ' && e === "All" && (creatorAssetCategory.length < res[$i].length - 1)) {
                        //console.log("enter " + res[$i].categoryName)
                        creatorAssetCategory.push(res[$i].categoryName)
                        setcreatorAssetCategory(creatorAssetCategory)
                        //console.log(creatorAssetCategory)
                    }
                }
                if (res) { CommonUtilities.RemoveBtnLoading("assets"); }
            })
        } else if (detailSubTab === 4) {
            directoryServices.BundleAssetListing(bundlePayLoad).then((res) => {
                setcreatorAssetList(res)
                //console.log(res)
                creatorAssettotalRow = res[0] ? res[0].totalRows : 0;
                setcreatorAssettotalRow(creatorAssettotalRow)
            })
        }

    }

    const loadClassificationListing = () => {

        SubclassFicationPayload.referenceCode = selectedDetail.kontactCode;
        directoryServices.tagListing(SubclassFicationPayload).then((res) => {
            setassociatedSubclassification(res)
        })

        directoryServices.musicDirectoryCategoryListing({ code: selectedDetail.kontactCode, CategoryType: "Creators" }).then((res) => {
            setassociatedclassification(res)
        })
    }

    const set_detailSubTab = (e: any) => {
        detailSubTab = e
        setActivedetailCategory('All')
        setdetailSubTab(detailSubTab)
    }

    const relatedAssetListing = () => {

        console.log(relatedAssetPayLoad)
        directoryServices.creatorRelatedAsset(relatedAssetPayLoad).then((res) => {
            setcreatorRelatedAsset(res)
            console.log(res)
            creatorAssettotalRow = res[0] ? res[0].totalRows : 0;
            setcreatorAssettotalRow(creatorAssettotalRow)
        })
    }

    const relatedArtistListing = () => {
        directoryServices.creatorRelatedArtist(relatedAssetPayLoad).then((res) => {
            setcreatorRelatedArtist(res)
            console.log(res)
            creatorAssettotalRow = res[0] ? res[0].totalRows : 0;
            setcreatorAssettotalRow(creatorAssettotalRow)
        })
    }

    const onChangeClose = (e: any) => {
        setdialogueOpenView(false);
        console.log('ddd');
        refreshDataListing(detailMainTab);
    }

    const refreshDataListing = (tabNum: any) => {
        if (tabNum === 1) {
            creatorAsset('All');
        }
        if (tabNum === 2) {
            relatedAssetListing();
        }
        if (tabNum === 3) {
            relatedArtistListing();
        }
    }

    const onArtistManagementClose = (e: any) => {
        setdialogueArtistOpenView(false);
        refreshDataListing(detailMainTab);
    }

    const onAddClose = (e: any) => {

        console.log("onAddClose")
        if (detailView) {
            setselectedDetail(e);
            loadClassificationListing();
            refreshDataListing(detailMainTab);
        }
        if (!detailView) {
            setselectedDetail([]);
            LandingListing();
        }
        setdialogueAddOpenView(false);
    }

    const Confirmation = (e: any) => {

        console.log(e)
        if (e === 1) {
            directoryServices.creatorsDeletion(selectedDetail)
            setdetailView(false)
            setActiveCategory("All");
            LandingListing();
        }
        setDelete(false);
    }

    const removeTabName = (value: any) => {
        exclude = exclude.filter((e: any) => e !== value)
        setExclude(exclude);
        splitArray(exclude)
    }

    const addTabName = (value: any) => {
        if (exclude.filter((e: any) => e === value).length === 0) {
            exclude.push(value)
            setExclude(exclude);
            splitArray(exclude)
        }
    }

    const splitArray = (value: any) => {
        var string = "";

        console.log(exclude)
        console.log(categoryList)

        const resultArray1 = categoryList.filter(item => !exclude.includes(item));
        console.log(resultArray1.toString())

        if (resultArray1.length > 0) {
            string = resultArray1.toString();
        }

        if (exclude.length === categoryList.length) {
            string = "";
        }

        if (exclude.length === 0) {
            string = categoryList.toString();
        }

        if (exclude.length === categoryList.length) {
            pagination.exclude = "";
        }

        pagination.exclude = string;
        directoryServices.creatorsListing({ ...pagination }).then((res) => {
            setdirectoryFullListing(res)
            settotalRow(res[0] ? res[0].totalRows : 0)

        })
    }

    const ExportResultSet = () => {
        console.log(pagination)
        var payload = { ...pagination, ...{ exportType: "exportType", export: 1 } }
        console.log(payload)
        directoryServices.excelGenericExport(payload)
    }

    let [summaryPayload, setSummaryPayload] = useState<any>([]);
    const onChangeSummary = (summaryChange: any) => {
        //console.log(summaryChange)
        summaryPayload = summaryChange;
        setSummaryPayload(summaryPayload)
    }


    let [newClassName, setNewClassName] = useState('')
    const saveNewClass = () => {

        console.log(categoryList)
        directoryServices.zFreeTextsave({ formArea: "Creators", useFreeText: newClassName }).then((valueListing: any) => {

            let clases_list: any = [];
            directoryServices.zFreeTextListing({ formArea: "Creators" }).then((valueListing: any) => {

                for (var i = 0; i < valueListing.length; i++) {
                    clases_list.push(valueListing[i].useFreeText)
                }

                clases_list.push("Uncategorised")

                if (clases_list.length > 0) {
                    console.log(clases_list)
                    exclude = clases_list;
                    setExclude(exclude);
                }
            })

        })

    }

    return (<>
        <div className="landing ws-12">

            <div className="ws-12">
                {(detailView === false) && <div className="plxl prxl">
                    <div className="ptxl mtl ptl">
                        <div className="ws-9">
                            <span className="ws-12 text-bold text-xl">Music Directories</span>
                            <span className="ws-12 ptl text-bold text-m turquoise">Creators</span>
                        </div>

                        <div className="ws-3">
                            <a className="icon-btn edit pull-right width100 height35" onClick={() => ExportResultSet()}>Export </a>
                            <a className="btn bg-level7 white pull-right pm btn-m forceSingleLine" onClick={() => { setdialogueAddOpenView(true); selectedDetail = []; }}>Add new Creator</a>
                        </div>
                    </div>

                    <div className="ws-12 ptxl">
                        <CommonSearch SearchForHandle={SearchForHandle} type="contactGrid" title="Creators" width="ws-12 pull-left" />
                    </div>

                    <div className="ws-12 mtl mbl"><>

                        <div className="ws-12 box">

                            <div className="pm ws-12">
                                <span className="pull-left pt text-bold text-m mr mt">Classes : </span>

                                {exclude?.map((list: any) => {
                                    return (
                                        <>{<div className="tagging bg-level1 mr forceSingleLine">
                                            <span className="bgTransparent text-bold">{list}</span>
                                            <a className="icon-btn info pull-left btn-xxs borderNone bgTransparent m0" onClick={() => removeTabName(list)}><i className="icon-cross1 text-s mt"></i></a>
                                        </div>}</>
                                    )
                                })}
                                <a className="p0 pull-left icon-btn edit borderNone bgTransparent m0" onClick={() => setOpenInclude(!openInclude)}><i className="icon-plus text-xxl"></i></a>
                            </div>

                            {openInclude && <> <hr />
                                <div className="pm ws-12">
                                    {categoryList?.map((list: any) => {
                                        return (<>
                                            {(() => {
                                                if (exclude.filter((e: any) => e === list).length === 0) {
                                                    return (
                                                        <div className="tagging bg-level1 mr forceSingleLine">
                                                            <span className="bgTransparent text-bold">{list}</span>
                                                            <a className="icon-btn info pull-left btn-xxs borderNone bgTransparent" onClick={() => addTabName(list)}>
                                                                <i className="icon-plus2 text-s mt"></i>
                                                            </a>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                        </>)
                                    })}
                                    <div className="ws-3 pull-left">
                                        <input placeholder="new class" className="ws-8" value={newClassName} onChange={(e: any) => setNewClassName(e.target.value)}></input>
                                        <button className="icon-btn edit" disabled={newClassName.length === 0} onClick={saveNewClass}>
                                            <i className="icon-save"></i>
                                        </button>
                                    </div>
                                </div>

                                {(categoryList && categoryList?.length === 0) && <div className="ws-12"><span className="text-center text-bold ws-12 mtl"> No Data Available. </span></div>}

                            </>}
                        </div>

                        <div className="ws-12 ptl pt pb">
                            <span className="text-bold text-m">Showing <span className="info">{totalRow}</span> results</span>
                        </div>

                        {(directoryFullListing.length > 0) && <>
                            {directoryFullListing?.map((valueObj: any) => {
                                return (
                                    <div className="ws-12 mt pt pb">
                                        {(valueObj && valueObj.categoryName !== "Uncategorised") && <>
                                            {<span className="ws-12 pt">
                                                <span className="text-bold pt">{valueObj.categoryName}</span>
                                                <span className="info text-bold pl">(Showing {valueObj?.categoryDetails?.length} out of  {valueObj.categoryDetails ? valueObj.categoryDetails[0].totalSubRows : 0})</span>
                                                {((valueObj.categoryDetails && valueObj.categoryDetails[0].totalSubRows) > 5) && <a className="icon-btn primary pull-right bg-level15 white borderNone hide" onClick={() => { viewAll(valueObj.categoryName); setviewAllList(valueObj.categoryName) }}> View All</a>}
                                            </span>}

                                            {valueObj.categoryDetails?.map((value: any, index: any) => {

                                                if (viewAllList !== valueObj.categoryName) {
                                                    return (
                                                        <>{(index < 10) && <div className="creatorImg pm pull-left">

                                                            <div className="box shadowCoverPicture shadow miniCreatorImg" onClick={() => { setdetailView(true); selectedDetail = (value); creatorAsset("All"); loadClassificationListing(); }}>

                                                                <div className="coverPicture">

                                                                    <div className="labelOverlay mt">
                                                                        {
                                                                            value?.categoryList?.split(',').map((values: any) => {

                                                                                return (
                                                                                    <span className="icon-btn primary btn-xxs mb text-normal"> {values}</span>

                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                    <img alt="Korrect" className="ws-12" src={value.creatorImage} onError={(e: any) => { e.src = '../../../../assets/images/NoReleaseImage.jpg' }} />
                                                                </div>
                                                                <div className="bottomOverlayLabel">
                                                                    <label className="control-label ws-12"> {CommonUtilities.longCharacter(value.kontactName, 17)}</label>
                                                                    <label className="control-label ws-12 hide"> {value.kontactCode} </label>
                                                                </div>
                                                            </div>
                                                        </div>}</>
                                                    )
                                                }

                                            })}

                                            {(() => {
                                                if (viewAllList === valueObj.categoryName && directoryViewAll?.length > 0) {
                                                    return (<>{directoryViewAll?.map((values: any) => {
                                                        return (<div className="creatorImg pm pull-left">
                                                            <div className="box shadowCoverPicture shadow miniCreatorImg" onClick={() => { setdetailView(true); selectedDetail = (values); creatorAsset("All"); loadClassificationListing(); }}>

                                                                <div className="coverPicture">
                                                                    <img alt="Korrect" className="ws-12" src={values.creatorImage} onError={(e: any) => { e.src = '../../../../assets/images/NoReleaseImage.jpg' }} />
                                                                </div>
                                                                <div className="bottomOverlayLabel">
                                                                    <label className="control-label ws-12"> {CommonUtilities.longCharacter(values.kontactName, 17)}</label>
                                                                    <label className="control-label ws-12 hide"> {values.kontactCode} </label>
                                                                </div>
                                                            </div>
                                                        </div>)
                                                    })}</>)
                                                }

                                            })()}

                                            {(valueObj?.categoryDetails[0]?.totalSubRows > 10) && <div className="ptl ws-12">
                                                 <Pagination onPageChange={(e: any) => paginationAllCategory({ pagination: e, categoryName: valueObj.categoryName })}
                                                    totalRow={valueObj.categoryDetails[0].totalSubRows} resetVal={resetVal} />
                                            </div>}

                                        </>}
                                    </div>
                                )
                            })}

                            {directoryFullListing?.map((valueObj: any) => {
                                return (
                                    <div className="ws-12 mt">
                                        {(valueObj && valueObj.categoryName === "Uncategorised") && <>
                                            {<span className="ws-12 mt">
                                                <span className="text-bold pull-left"> Uncategorised</span>
                                                <span className="info text-bold pl">(Showing {valueObj?.categoryDetails?.length} out of {valueObj.categoryDetails ? valueObj.categoryDetails[0].totalSubRows : 0})</span>
                                                {((valueObj.categoryDetails && valueObj.categoryDetails[0].totalSubRows) > 5) &&
                                                    <a className="icon-btn primary pull-right bg-level15 white borderNone hide" onClick={() => { viewAll(valueObj.categoryName); setviewAllList(valueObj.categoryName) }}> View All </a>
                                                }
                                            </span>}

                                            {valueObj?.categoryDetails?.map((value: any, index: any) => {
                                                if (viewAllList !== valueObj.categoryName && valueObj.categoryName === "Uncategorised") {
                                                    return (
                                                        <>{(index < 10) && <div className="creatorImg pm pull-left">

                                                            <div className="box shadowCoverPicture shadow miniCreatorImg" onClick={() => { setdetailView(true); selectedDetail = (value); creatorAsset("All"); loadClassificationListing(); }}>

                                                                <div className="coverPicture">
                                                                    <img alt="Korrect" className="ws-12" src={value.creatorImage} onError={(e: any) => { e.src = '../../../../assets/images/NoReleaseImage.jpg' }} />

                                                                </div>
                                                                <div className="bottomOverlayLabel">
                                                                    <label className="control-label ws-12"> {CommonUtilities.longCharacter(value.kontactName, 17)}</label>
                                                                    <label className="control-label ws-12 hide"> {value.kontactCode} </label>
                                                                </div>
                                                            </div>
                                                        </div>}</>
                                                    )
                                                }

                                            })}

                                            {(() => {
                                                if (valueObj.categoryName === "Uncategorised" && viewAllList === valueObj.categoryName && viewAllList === "Uncategorised") {
                                                    return (<div className="ws-12">
                                                        {directoryViewAll.map((values: any) => {
                                                            return (
                                                                <div className="creatorImg pm pull-left">
                                                                    <div className="box shadowCoverPicture shadow miniCreatorImg" onClick={() => { setdetailView(true); selectedDetail = values; creatorAsset("All"); loadClassificationListing(); }}>

                                                                        <div className="coverPicture">
                                                                            <img alt="Korrect" className="ws-12" src={values.creatorImage} onError={(e: any) => { e.src = '../../../../assets/images/NoReleaseImage.jpg' }} />

                                                                        </div>
                                                                        <div className="bottomOverlayLabel">
                                                                            <label className="control-label ws-12"> {CommonUtilities.longCharacter(values.kontactName, 17)}</label>
                                                                            <label className="control-label ws-12 hide"> {values.kontactCode} </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}

                                                    </div>)
                                                }
                                            })()}

                                            {(valueObj?.categoryDetails[0]?.totalSubRows > 10) && <div className="ws-12">
                                                 <Pagination onPageChange={(e: any) => paginationAllCategory({ pagination: e, categoryName: valueObj.categoryName })}
                                                    totalRow={valueObj.categoryDetails ? valueObj.categoryDetails[0].totalSubRows : 0} resetVal={resetVal} />
                                            </div>}

                                        </>}
                                    </div>
                                )
                            })}
                        </>}
                    </> </div>
                </div>}

                {(detailView === true) && <>
                    <div className="ws-12">
                        <div className="ws-12 pLarge">
                            <button className="icon-btn primary btn-sm mrl" onClick={() => { setdetailView(false); selectedDetail = []; setselectedDetail([]) }}>
                                <i className="icon-angle-left"></i>
                            </button>

                            <div className="mt">
                                <span className="text-bold pt" style={{ textDecoration: "underline" }}> Creators directory</span>
                                <span className="text-bold pt"> {">"} {selectedDetail.kontactName}</span>
                            </div>
                        </div>
                        <hr />
                    </div>

                    <div className="ws-12 pLarge">
                        <div className="ws-12">
                            <div className="box shadow" style={{ width: "100px", height: "100px" }}>
                                <div className="coverPicture" style={{ height: "200px" }}>
                                    <img alt="Korrect" className="ws-12" src={selectedDetail.creatorImage} onError={(e: any) => { e.src = '../../../../assets/images/NoReleaseImage.jpg' }} />
                                </div>
                            </div>

                            <div className="ws-8 mtl pt pll">
                                <div className="ws-12 text-xl text-bold mbl ptl pl">{selectedDetail.kontactName} ( {selectedDetail.kontactCode} )</div>
                                <>
                                    {associatedclassification?.map((values: any) => {
                                        return (<span className="btn pull-left btn-black">{values.categoryName}</span>)
                                    })}
                                </>

                                <>
                                    {associatedSubclassification?.map((values: any) => {
                                        return (<span className="btn pull-left btn-blackBorder">{values.text}</span>)
                                    })}
                                </>
                            </div>

                            <div className="verticalMediumWide hover-box">
                                <ul className="hover-block textboxDropdownList box pLarge defaultColor rightReset ws-2">
                                    <li className="ws-12 pbs"> <a onClick={() => { setdialogueOpenView(true); }}>  Add Asset </a> </li>
                                    <li className="ws-12 pbs"> <a onClick={() => { setdialogueAddOpenView(true) }}>Edit Profile</a> </li>
                                    <li className="ws-12 pbs"> <a onClick={() => { setdialogueArtistOpenView(true) }}>Manage Related Artists</a></li>
                                    <hr className="ws-12  m0 pbs" />
                                    <li className="ws-12 danger "><a onClick={() => setDelete(true)} style={{ color: "red" }}>Delete Creator</a></li>
                                </ul>
                                <button className="btn icon-btn info pull-right pt">
                                    <i className="icon-grid m0 p0"></i>
                                </button>
                            </div>
                        </div>

                        <div className="ws-12 m0">
                            <ul className="nav nav-tabs ws-12 mbll mtll ws-12 p0">
                                <li onClick={() => setdetailMainTab(5)} className={detailMainTab === 5 ? "mrl active" : "mrl"}>Summary</li>
                                <li onClick={() => setdetailMainTab(4)} className={detailMainTab === 4 ? "mrl active" : "mrl"}>Analytics</li>
                                <li id="assets" onClick={() => (setdetailMainTab(1), set_detailSubTab(1), creatorAsset('All'))} className={detailMainTab === 1 ? "active buttonLoad" : "buttonLoad"}>Assets</li>
                                <li onClick={() => { setdetailMainTab(2); relatedAssetListing() }} className={detailMainTab === 2 ? "mrl active " : "mrl"}>Related Assets</li>
                                <li onClick={() => { setdetailMainTab(3); relatedArtistListing() }} className={detailMainTab === 3 ? "mrl active" : "mrl"}>Related Artists</li>
                            </ul>
                        </div>

                        {(detailMainTab === 1) && <div className="forceSingleLine pull-left">

                            <ul className="nav nav-tabs ws-12 mbll ws-12 p0">
                                <li className={detailSubTab === 1 ? "mrl prxl active" : "mrl prxl"} onClick={() => { set_detailSubTab(1); creatorAsset('All') }}>Tracks</li>
                                <li className={detailSubTab === 2 ? "mrl prxl active" : "mrl prxl"} onClick={() => { set_detailSubTab(2); creatorAsset('All') }}> Songs </li>
                                <li className={detailSubTab === 3 ? "mrl prxl active" : "mrl prxl"} onClick={() => { set_detailSubTab(3); creatorAsset('All') }}>Releases</li>
                                <li className={detailSubTab === 4 ? "mrl prxl active hide" : "mrl prxl hide"} onClick={() => { set_detailSubTab(4); creatorAsset('All') }}>Bundles </li>

                            </ul>
                        </div>}

                    </div>

                    <div className="landing ws-12 pll">
                        {(detailMainTab === 1) && <div className="forceSingleLine pull-left ws-12 pl">
                            <div className="box-content p0 mtl">
                                <h2>Showing <span className="info">{creatorAssettotalRow}</span> results</h2>

                                {(detailSubTab < 4 && creatorAssettotalRow > 0) && <div className="ws-9">
                                    <ul className="nav nav-tabs p0 m0">
                                        <li key='All' className={activedetailCategory === 'All' ? "m0 mt mr  borderNone  plxl prxl active" : "m0 mt mr  borderNone  plxl prxl "}
                                            onClick={() => { setActivedetailCategory('All'); creatorAsset('All') }}> All
                                        </li>
                                        {creatorAssetCategory?.map((values: any) => {
                                            return (
                                                <li key='All' className={activedetailCategory === values ? "m0 mt mr  borderNone  plxl prxl active" : "m0 mt mr  borderNone  plxl prxl "}
                                                    onClick={() => { setActivedetailCategory(values); creatorAsset(values) }}>
                                                    {values}
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>}
                            </div>

                            <div className="ws-12">
                                {(() => {
                                    if (detailSubTab < 4) {

                                        return (creatorAssetList?.map((value: any) => {
                                            return (
                                                value.categoryDetails?.map((values: any) => {
                                                    return (
                                                        <div className="creatorImg pm pull-left" >
                                                            <div className="box shadowCoverPicture shadow miniCreatorImg">
                                                                <div className="coverPicture">
                                                                    <img alt="Korrect" className="ws-12" src={values.assetImage} onError={(e: any) => { e.src = '../../../../assets/images/NoReleaseImage.jpg' }} />
                                                                </div>

                                                                <i className="icon-pictures1 primary pull-none coverPicture ptl hide" ></i>

                                                                <div className="bottomOverlayLabel">
                                                                    <label className="control-label ws-12">{values.name}</label>
                                                                    <label className="control-label ws-12 text-bold text-uppercase"> {values.assetContactCode}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            )
                                        }))
                                    }

                                    if (detailSubTab === 4) {
                                        return (
                                            creatorAssetList?.map((values: any) => {
                                                return (
                                                    <div className="creatorImg pm pull-left" >

                                                        <div className="box shadowCoverPicture shadow miniCreatorImg">
                                                            <div className="coverPicture">
                                                                <img alt="Korrect" className="ws-12" src={values.assetImage} onError={(e: any) => { e.src = '../../../../assets/images/NoReleaseImage.jpg' }} />
                                                            </div>

                                                            <i className="icon-pictures1 primary pull-none coverPicture ptl hide" ></i>

                                                            <div className="bottomOverlayLabel">
                                                                <label className="control-label ws-12">{values.bundleTitle}</label>
                                                                <label className="control-label ws-12 text-bold text-uppercase"> {values.bundleCode}</label>
                                                            </div>
                                                        </div>

                                                    </div>
                                                )
                                            })
                                        )
                                    }
                                })()}
                            </div>

                        </div>}

                        {(detailMainTab === 2) && <div className="forceSingleLine pull-left ws-12">

                            <h2>Showing <span className="info">{creatorAssettotalRow}</span> results</h2>
                            {creatorRelatedAsset?.map((values: any) => {
                                return (
                                    <div className="creatorImg pm pull-left" >

                                        <div className="box shadowCoverPicture shadow miniCreatorImg">
                                            <div className="coverPicture">
                                                <div className="labelOverlay mt">
                                                    <span className="icon-btn primary btn-xs mb "> {values.musicAssetType}</span>
                                                </div>

                                                <img alt="Korrect" className="ws-12" src={values.assetImageTH} onError={(e: any) => { e.src = '../../../../assets/images/NoReleaseImage.jpg' }} />
                                            </div>

                                            <i className="icon-pictures1 primary pull-none coverPicture ptl hide" ></i>

                                            <div className="bottomOverlayLabel">
                                                <label className="control-label ws-12">{values.name}</label>
                                                <label className="control-label ws-12 text-bold text-uppercase"> {values.creatorCode}</label>
                                            </div>
                                        </div>

                                    </div>
                                )
                            })}
                        </div>}

                        {(detailMainTab === 3) && <div className="forceSingleLine pull-left ws-12">

                            <h2>Showing <span className="info">{creatorAssettotalRow}</span> results</h2>
                            {creatorRelatedArtist?.map((values: any) => {
                                return (
                                    <div className="creatorImg pm pull-left" >

                                        <div className="box shadowCoverPicture shadow miniCreatorImg">
                                            <div className="coverPicture">
                                                <img alt="Korrect" className="ws-12" src={values.creatorImage} onError={(e: any) => { e.src = '../../../../assets/images/NoReleaseImage.jpg' }} />
                                            </div>

                                            <i className="icon-pictures1 primary pull-none coverPicture ptl hide" ></i>

                                            <div className="bottomOverlayLabel">
                                                <label className="control-label ws-12">{CommonUtilities.longCharacter(values.kontactName, 18)}</label>
                                                <label className="control-label ws-12 text-bold text-uppercase"> {values.kontactCode}</label>
                                            </div>
                                        </div>

                                    </div>
                                )
                            })}
                        </div>}

                        {(detailMainTab === 4) && <div className="forceSingleLine pull-left ws-12 pl prl">
                            <DirectoryAnalytic onChangeSummary={onChangeSummary} selectedDetail={selectedDetail} DAOpen={detailMainTab === 4 ? "Creator" : "Close"} summaryPayload={summaryPayload} />
                        </div>}

                        {(detailMainTab === 5) && <div className="forceSingleLine pull-left ws-12">
                            <Summary type="Artist" code={{ "AssetArtist": selectedDetail.kontactCode }} onChangeSummary={onChangeSummary} />
                        </div>}

                        {(creatorAssettotalRow === 0) && (detailMainTab < 4) &&
                            <div className="ws-12 mtl prxl pbl pll">
                                <span className="alert alert-success ws-12 text-center">No data Available</span>
                            </div>}
                    </div>
                </>}
            </div>

            {(() => {
                if (dialogueOpenView) {
                    return (<AssetManagement onChangeClose={onChangeClose} open={dialogueOpenView} selectedDetail={selectedDetail} />)
                }

                if (dialogueArtistOpenView) {
                    return (<ArtistManagement onChangeClose={onArtistManagementClose} open={dialogueArtistOpenView} selectedDetail={selectedDetail} />)
                }

                if (dialogueAddOpenView) {
                    return (<AddCreator onChangeClose={onAddClose} open={dialogueAddOpenView} selectedDetail={selectedDetail ? selectedDetail : []} />)
                }

                if (deleteJob) {
                    return <DeleteDialogueBox param={true} message={"delete contact " + selectedDetail.kontactName + '(' + selectedDetail.kontactCode + ')'} onChange={Confirmation} />
                }
            })()}
        </div>
    </>)
}